import { Button } from 'components/button/Button';
import React, { useEffect, useRef, useState } from 'react';
import { useDispatch } from 'react-redux';
import { closeModal } from 'reducers/modal';
import CalculatorLogo from 'assets/apply.clevry/Icon_Guide_01.png';
import WatchLogo from 'assets/apply.clevry/Icon_Guide_02.png';
import PaperLogo from 'assets/apply.clevry/Icon_Guide_03.png';
import MobileLogo from 'assets/apply.clevry/Icon_Guide_04.png';
import DesktopLogo from 'assets/apply.clevry/Icon_Guide_05.png';
import CalculatorLogoYellow from 'assets/apply.clevry/Icon_Guide_01_Yellow.png';
import WatchLogoYellow from 'assets/apply.clevry/Icon_Guide_02_Yellow.png';
import PaperLogoYellow from 'assets/apply.clevry/Icon_Guide_03_Yellow.png';
import MobileLogoYellow from 'assets/apply.clevry/Icon_Guide_04_Yellow.png';
import DesktopLogoYellow from 'assets/apply.clevry/Icon_Guide_05_Yellow.png';
import CalculatorLogoWhite from 'assets/apply.clevry/Icon_Guide_01_White.png';
import WatchLogoWhite from 'assets/apply.clevry/Icon_Guide_02_White.png';
import PaperLogoWhite from 'assets/apply.clevry/Icon_Guide_03_White.png';
import MobileLogoWhite from 'assets/apply.clevry/Icon_Guide_04_White.png';
import DesktopLogoWhite from 'assets/apply.clevry/Icon_Guide_05_White.png';
import CalculatorLogoBlack from 'assets/apply.clevry/Icon_Guide_01_Black.png';
import WatchLogoBlack from 'assets/apply.clevry/Icon_Guide_02_Black.png';
import PaperLogoBlack from 'assets/apply.clevry/Icon_Guide_03_Black.png';
import MobileLogoBlack from 'assets/apply.clevry/Icon_Guide_04_Black.png';
import DesktopLogoBlack from 'assets/apply.clevry/Icon_Guide_05_Black.png';
import { useTranslation } from 'react-i18next';
import i18n from 'i18n/i18n';
import { useSelector } from 'react-redux';
import AccessibilitySwitcher from "helpers/accessibilitySwitcher";
import { selectAccessibilityData } from 'reducers/accessibility';

type IconGuideModalProps = {
  data: { title: string; modalClasses: string; modalHeaderClasses: string };
};

const IconGuideModal: React.FC<IconGuideModalProps> = ({ data }) => {
  const { t } = useTranslation('Icon+Guide+Modal', { i18n });
  const iconModal = useRef<HTMLInputElement>(null);

  const accessibilityData = useSelector(selectAccessibilityData);

  const dispatch = useDispatch();

  useEffect(() => {
    iconModal.current?.focus();
  }, [iconModal]);    

  const handleCloseModal = () => {
    dispatch(closeModal());
  };

  return (
    <div className="IconGuideModal FullWidth FullHeight">
      <div 
        className="Content"
        ref={iconModal}
        tabIndex={0}        
      >
        <div className="Paragraph">
          {t('SSCandidate_Icon_Guide_Modal_Intro_Txt')}
        </div>
        <div className="Paragraph">
          <img
            src={AccessibilitySwitcher(CalculatorLogo, CalculatorLogoYellow, CalculatorLogoWhite, CalculatorLogoBlack, accessibilityData)}
            alt={t('SSCandidate_Icon_Guide_Modal_Calculator_Icon')}
          />
          <div className="IconGuideText">
            <span className="IconGuideLabel">
              {t('SSCandidate_Icon_Guide_Modal_Calculator_Icon')}
            </span>{' '}
            - {t('SSCandidate_Icon_Guide_Modal_Calculator')}
          </div>
        </div>
        <div className="Paragraph">
          <img
            src={AccessibilitySwitcher(WatchLogo, WatchLogoYellow, WatchLogoWhite, WatchLogoBlack, accessibilityData)}
            alt={t('SSCandidate_Icon_Guide_Modal_Time_Limit_Icon')}
          />
          <div className="IconGuideText">
            <span className="IconGuideLabel">
              {t('SSCandidate_Icon_Guide_Modal_Time_Limit_Icon')}
            </span>{' '}
            - {t('SSCandidate_Icon_Guide_Modal_Time_Limit')}
          </div>
        </div>
        <div className="Paragraph">
          <img
            src={AccessibilitySwitcher(MobileLogo, MobileLogoYellow, MobileLogoWhite, MobileLogoBlack, accessibilityData)}
            alt={t('SSCandidate_Icon_Guide_Modal_Phone_Icon')}
          />

          <div className="IconGuideText">
            <span className="IconGuideLabel">
              {t('SSCandidate_Icon_Guide_Modal_Phone_Icon')}
            </span>{' '}
            - {t('SSCandidate_Icon_Guide_Modal_Mobile')}
          </div>
        </div>
        <div className="Paragraph">
          <img
            src={AccessibilitySwitcher(DesktopLogo, DesktopLogoYellow, DesktopLogoWhite, DesktopLogoBlack, accessibilityData)}
            alt={t('SSCandidate_Icon_Guide_Modal_Desktop_Icon')}
          />

          <div className="IconGuideText">
            <span className="IconGuideLabel">
              {t('SSCandidate_Icon_Guide_Modal_Desktop_Icon')}
            </span>{' '}
            - {t('SSCandidate_Icon_Guide_Modal_Desktop')}
          </div>
        </div>
      </div>
      <div className="ModalFooter">
        <Button priority="tertiary" type="button" onClick={handleCloseModal}>
          {t('SSCandidate_Icon_Guide_Modal_Cancel')}
        </Button>
        <Button priority="primary" type="submit" onClick={handleCloseModal}>
          {t('SSCandidate_Icon_Guide_Modal_Close')}
        </Button>
      </div>
    </div>
  );
};

export { IconGuideModal };
